function openDeliveryModal() {
    const modal = document.getElementById('deliveryModal');
    if (modal) {
        modal.classList.remove('hidden');
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
    }
}

function closeDeliveryModal() {
    const modal = document.getElementById('deliveryModal');
    if (modal) {
        modal.classList.add('hidden');
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }
}

window.openDeliveryModal = openDeliveryModal;
window.closeDeliveryModal = closeDeliveryModal;

document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('deliveryModal');

    if (modal) {
        modal.addEventListener('click', function (e) {
            if (e.target === this) {
                closeDeliveryModal();
            }
        });
    }
});